
/**
 * @license lucide v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $e30097a8c7ef5fcf$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": 2,
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
};


const $faf721be9a130e1f$export$2e2bcd8739ae039 = [
    "svg",
    (0, $e30097a8c7ef5fcf$export$2e2bcd8739ae039),
    [
        [
            "rect",
            {
                width: "8",
                height: "4",
                x: "8",
                y: "2",
                rx: "1",
                ry: "1"
            }
        ],
        [
            "path",
            {
                d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
            }
        ],
        [
            "path",
            {
                d: "M12 11h4"
            }
        ],
        [
            "path",
            {
                d: "M12 16h4"
            }
        ],
        [
            "path",
            {
                d: "M8 11h.01"
            }
        ],
        [
            "path",
            {
                d: "M8 16h.01"
            }
        ]
    ]
];

/**
 * @license lucide v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $b30846b9f2885346$var$createElement = (tag, attrs, children = [])=>{
    const element = document.createElementNS("http://www.w3.org/2000/svg", tag);
    Object.keys(attrs).forEach((name)=>{
        element.setAttribute(name, String(attrs[name]));
    });
    if (children.length) children.forEach((child)=>{
        const childElement = $b30846b9f2885346$var$createElement(...child);
        element.appendChild(childElement);
    });
    return element;
};
var $b30846b9f2885346$export$2e2bcd8739ae039 = ([tag, attrs, children])=>$b30846b9f2885346$var$createElement(tag, attrs, children);


const $544fadf3576dc5dd$export$10924a90f5ba4e1c = (element)=>Array.from(element.attributes).reduce((attrs, attr)=>{
        attrs[attr.name] = attr.value;
        return attrs;
    }, {});
const $544fadf3576dc5dd$export$18505e447a7bb2d5 = (attrs)=>{
    if (typeof attrs === "string") return attrs;
    if (!attrs || !attrs.class) return "";
    if (attrs.class && typeof attrs.class === "string") return attrs.class.split(" ");
    if (attrs.class && Array.isArray(attrs.class)) return attrs.class;
    return "";
};
const $544fadf3576dc5dd$export$189053d41e721fcb = (arrayOfClassnames)=>{
    const classNameArray = arrayOfClassnames.flatMap($544fadf3576dc5dd$export$18505e447a7bb2d5);
    return classNameArray.map((classItem)=>classItem.trim()).filter(Boolean).filter((value, index, self)=>self.indexOf(value) === index).join(" ");
};
const $544fadf3576dc5dd$var$toPascalCase = (string)=>string.replace(/(\w)(\w*)(_|-|\s*)/g, (g0, g1, g2)=>g1.toUpperCase() + g2.toLowerCase());
const $544fadf3576dc5dd$export$2e2bcd8739ae039 = (element, { nameAttr: nameAttr, icons: icons, attrs: attrs })=>{
    const iconName = element.getAttribute(nameAttr);
    if (iconName == null) return;
    const ComponentName = $544fadf3576dc5dd$var$toPascalCase(iconName);
    const iconNode = icons[ComponentName];
    if (!iconNode) return console.warn(`${element.outerHTML} icon name was not found in the provided icons object.`);
    const elementAttrs = $544fadf3576dc5dd$export$10924a90f5ba4e1c(element);
    const [tag, iconAttributes, children] = iconNode;
    const iconAttrs = {
        ...iconAttributes,
        "data-lucide": iconName,
        ...attrs,
        ...elementAttrs
    };
    const classNames = $544fadf3576dc5dd$export$189053d41e721fcb([
        "lucide",
        `lucide-${iconName}`,
        elementAttrs,
        attrs
    ]);
    if (classNames) Object.assign(iconAttrs, {
        class: classNames
    });
    const svgElement = (0, $b30846b9f2885346$export$2e2bcd8739ae039)([
        tag,
        iconAttrs,
        children
    ]);
    return element.parentNode?.replaceChild(svgElement, element);
};

























































































































































































































































































































































































































































































































































































































































































































































































































/**
 * @license lucide v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d88da4c319b2ab77$export$2e2bcd8739ae039 = [
    "svg",
    (0, $e30097a8c7ef5fcf$export$2e2bcd8739ae039),
    [
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "10"
            }
        ],
        [
            "path",
            {
                d: "m4.93 4.93 4.24 4.24"
            }
        ],
        [
            "path",
            {
                d: "m14.83 9.17 4.24-4.24"
            }
        ],
        [
            "path",
            {
                d: "m14.83 14.83 4.24 4.24"
            }
        ],
        [
            "path",
            {
                d: "m9.17 14.83-4.24 4.24"
            }
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                r: "4"
            }
        ]
    ]
];


















































/**
 * @license lucide v0.407.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $35e163094e58176b$export$2e2bcd8739ae039 = [
    "svg",
    (0, $e30097a8c7ef5fcf$export$2e2bcd8739ae039),
    [
        [
            "rect",
            {
                width: "20",
                height: "16",
                x: "2",
                y: "4",
                rx: "2"
            }
        ],
        [
            "path",
            {
                d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
            }
        ]
    ]
];










































































































































































































































































































































































































































































































































































































































































const $c50b50dbf857a71d$export$f8761611413a374e = ({ icons: icons = {}, nameAttr: nameAttr = "data-lucide", attrs: attrs = {} } = {})=>{
    if (!Object.values(icons).length) throw new Error("Please provide an icons object.\nIf you want to use all the icons you can import it like:\n `import { createIcons, icons } from 'lucide';\nlucide.createIcons({icons});`");
    if (typeof document === "undefined") throw new Error("`createIcons()` only works in a browser environment.");
    const elementsToReplace = document.querySelectorAll(`[${nameAttr}]`);
    Array.from(elementsToReplace).forEach((element)=>(0, $544fadf3576dc5dd$export$2e2bcd8739ae039)(element, {
            nameAttr: nameAttr,
            icons: icons,
            attrs: attrs
        }));
    if (nameAttr === "data-lucide") {
        const deprecatedElements = document.querySelectorAll("[icon-name]");
        if (deprecatedElements.length > 0) {
            console.warn("[Lucide] Some icons were found with the now deprecated icon-name attribute. These will still be replaced for backwards compatibility, but will no longer be supported in v1.0 and you should switch to data-lucide");
            Array.from(deprecatedElements).forEach((element)=>(0, $544fadf3576dc5dd$export$2e2bcd8739ae039)(element, {
                    nameAttr: "icon-name",
                    icons: icons,
                    attrs: attrs
                }));
        }
    }
};


var $35da740d59af89ba$require$createIcons = $c50b50dbf857a71d$export$f8761611413a374e;
var $35da740d59af89ba$require$Mail = $35e163094e58176b$export$2e2bcd8739ae039;
var $35da740d59af89ba$require$ClipboardList = $faf721be9a130e1f$export$2e2bcd8739ae039;
var $35da740d59af89ba$require$LifeBuoy = $d88da4c319b2ab77$export$2e2bcd8739ae039;
$35da740d59af89ba$require$createIcons({
    icons: {
        Mail: $35da740d59af89ba$require$Mail,
        ClipboardList: $35da740d59af89ba$require$ClipboardList,
        LifeBuoy: $35da740d59af89ba$require$LifeBuoy
    }
});


//# sourceMappingURL=index.084d599d.js.map
